import { z } from "zod";
import { gql } from "graphql-request";
import { NewsEntrySchema } from "./newsEntry";

import {
  NewsEntryArticleFragment,
  NewsEntryArticleSchema,
} from "./newsEntryArticle";
import { NewsEntryVideoFragment, NewsEntryVideoSchema } from "./newsEntryVideo";
import {
  NewsEntryExternalLinkFragment,
  NewsEntryExternalLinkSchema,
} from "./newsEntryExternalLink";
import { SysFragment } from "../sys";
import {
  SmallNewsEntryExternalLinkFragment,
  SmallNewsEntryExternalLinkSchema,
} from "./smallNewsEntryExternalLink";
import {
  SmallNewsEntryArticleFragment,
  SmallNewsEntryArticleSchema,
} from "./smallNewsEntryArticle";

import {
  EsportRewatchMatchEntrySchema,
  EsportRewatchMatchEntryFragment,
} from "./esportRewatchMatchEntry";
import { TargetingFragment } from "../targeting";
import { RelatedMediaFragment } from "../relatedMedia";

export const EsportNewsEntrySchema = NewsEntrySchema.extend({
  localized: z
    .discriminatedUnion("__typename", [
      NewsEntryArticleSchema,
      NewsEntryVideoSchema,
      NewsEntryExternalLinkSchema,
      SmallNewsEntryArticleSchema,
      SmallNewsEntryExternalLinkSchema,
      EsportRewatchMatchEntrySchema,
    ])
    .nullish(),
});

export const EsportNewsEntry = EsportNewsEntrySchema;
export type EsportNewsEntry = z.infer<typeof EsportNewsEntrySchema>;

export const EsportNewsEntryFragment = gql`
  fragment EsportNewsEntryFragment on EsportNewsEntry {
    sys {
      ...SysFragment
    }
    category {
      name
      color
      secondaryColor
    }
    newUntil
    sortDate

    targeting {
      ...TargetingFragment
    }

    relatedMedia {
      ...RelatedMediaFragment
    }

    localized {
      __typename

      ... on NewsEntryVideo {
        ...NewsEntryVideoFragment
      }

      ... on NewsEntryExternalLink {
        ...NewsEntryExternalLinkFragment
      }

      ... on NewsEntryArticle {
        ...NewsEntryArticleFragment
      }

      ... on SmallNewsEntryArticle {
        ...SmallNewsEntryArticleFragment
      }

      ... on SmallNewsEntryExternalLink {
        ...SmallNewsEntryExternalLinkFragment
      }

      ... on EsportRewatchMatchEntry {
        ...EsportRewatchMatchEntryFragment
      }
    }
  }

  ${NewsEntryArticleFragment}
  ${NewsEntryVideoFragment}
  ${NewsEntryExternalLinkFragment}
  ${SmallNewsEntryExternalLinkFragment}
  ${SmallNewsEntryArticleFragment}
  ${EsportRewatchMatchEntryFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
  ${SysFragment}
`;
